const acc = document.getElementsByClassName("description_accordion");
let i;
for(i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    const sign = this.children[1];
    const panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      sign.textContent = "+";
      panel.style.maxHeight = null;
    } else {
      sign.textContent = "-";
      panel.style.maxHeight = panel.scrollHeight + "px";
      let j;
      for(j = 0; j < acc.length; j++) {
        if(this.classList != acc[j].classList) {
          acc[j].classList.remove("active");
          acc[j].children[1].textContent = "+";
          acc[j].style.maxHeight = null;
          acc[j].nextElementSibling.style.maxHeight = null;
        }
      }
    }
  });
}
